module.exports = __webpack_public_path__ + "media/images/teaser-icon-medal-border-2b9d93e354f9c39d280bbd8c54d85c04.svg";